module.exports = __webpack_public_path__ + "assets/instagram-logo.ecf55965.svg";